import type { TeacherLessonRecord } from "../auth/api-client";

export function lessonIsPublished(lesson: Pick<TeacherLessonRecord, "communityPublishStatus">): boolean {
  const status = lesson.communityPublishStatus ?? "private";
  return status === "approved" || status === "pending_review";
}

/** True when the lesson is on a course template or assigned in an active cohort. */
export function lessonIsLanded(lesson: Pick<TeacherLessonRecord, "usedInTemplates" | "activeCohorts">): boolean {
  return (lesson.usedInTemplates ?? 0) > 0 || (lesson.activeCohorts ?? 0) > 0;
}

export function lessonCanMoveToDrafts(
  lesson: Pick<TeacherLessonRecord, "communityPublishStatus" | "usedInTemplates" | "activeCohorts">
): boolean {
  return !lessonIsPublished(lesson) && !lessonIsLanded(lesson);
}
